import { connect } from 'react-redux';
import { getFlags } from '@wix/da-react-context/pkg/flags/redux/selectors';
import { getThemeSkin, getPageThumb, getSeoCanonical, getIsMobile, getSeoTitle, getSeoDescription, getSeoPrevUrl, getSeoNextUrl, getSeoRating, getIsIOS } from '../../publicSession/selectors';
import { getChatNewMessageArrived } from '../../Chat/redux/selectors';
const mapStateToProps = (state, ownProps)=>({
        flags: getFlags(state),
        isMobile: getIsMobile(state),
        isIOS: getIsIOS(state),
        themeSkin: ownProps.themeSkin || getThemeSkin(state),
        pageThumb: getPageThumb(state),
        pageUrl: getSeoCanonical(state),
        pageTitle: getSeoTitle(state),
        pageDescription: getSeoDescription(state),
        pageRating: getSeoRating(state),
        hasNewChatMessage: getChatNewMessageArrived(state),
        prevUrl: getSeoPrevUrl(state),
        nextUrl: getSeoNextUrl(state)
    });
export default connect(mapStateToProps);

//# sourceMappingURL=Head.container.js.map